import styled from 'styled-components';
import { propStyling } from '../../shared/propStyling';
import { textStyles } from '../../shared/textStyles';
import { tombac } from '../../shared/tombac';
export const Caption = styled.span.withConfig({
  displayName: "Caption"
})(["all:initial;", " ", " ", ""], tombac.typography.caption, textStyles, propStyling);
//# sourceMappingURL=Caption.js.map